import { Feature } from "geojson";
import { useEffect } from "react";

type UseDragCursorProps<T extends Feature = Feature> = {
    map: mapboxgl.Map | null;
    isDragging: boolean;
    hoveredFeature: T | null;
};

/**
 * Updates cursor style based on drag state
 */
export function useDragCursor<T extends Feature = Feature>({ map, isDragging, hoveredFeature }: UseDragCursorProps<T>) {
    useEffect(() => {
        if (!map || !isDragging) return;

        const cursor = hoveredFeature ? "copy" : "grabbing";
        map.getCanvas().style.cursor = cursor;

        return () => {
            if (map) {
                map.getCanvas().style.cursor = "";
            }
        };
    }, [map, isDragging, hoveredFeature]);
}
